export const STYLES = `
:host {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 200px;
}

.xv {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: var(--xv-background, #ffffff);
  font-family: var(--xv-ui-font, "Segoe UI", Arial, sans-serif);
}

.xv__message {
  display: none;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
  color: var(--xv-text, #000000);
}

.xv[data-state="loading"] .xv__message,
.xv[data-state="error"] .xv__message,
.xv[data-state="empty"] .xv__message {
  display: flex;
}

.xv[data-state="error"] .xv__message {
  color: var(--xv-error, #c00000);
}

.xv__spinner {
  width: 32px;
  height: 32px;
  border: 4px solid var(--xv-head-border, #d4d4d4);
  border-top-color: var(--xv-accent, #217346);
  border-radius: 50%;
  animation: xv-spin 0.8s linear infinite;
}

.xv__sheet,
.xv__tabs {
  display: none;
}

.xv[data-state="ready"] .xv__sheet {
  display: block;
}

.xv[data-state="ready"] .xv__tabs {
  display: flex;
}

.xv__sheet {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.xv__area {
  position: absolute;
  overflow: hidden;
}

.xv__inner {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
}

.xv__corner,
.xv__head {
  position: absolute;
  box-sizing: border-box;
  background: var(--xv-head-background, #f3f3f3);
  border-right: 1px solid var(--xv-head-border, #d4d4d4);
  border-bottom: 1px solid var(--xv-head-border, #d4d4d4);
}

.xv__head {
  overflow: hidden;
  color: var(--xv-head-text, #444444);
  text-align: center;
  white-space: nowrap;
  user-select: none;
}

.xv__head--selected {
  background: var(--xv-head-selected, #d2d2d2);
  color: var(--xv-accent, #217346);
}

.xv__head--col.xv__head--selected {
  border-bottom: 2px solid var(--xv-accent, #217346);
}

.xv__head--row.xv__head--selected {
  border-right: 2px solid var(--xv-accent, #217346);
}

.xv__freeze {
  position: absolute;
  background: var(--xv-freeze, #9b9b9b);
  pointer-events: none;
}

.xv__scroller {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: scroll;
  outline: none;
  user-select: none;
  cursor: cell;
}

.xv__cell-text {
  display: none;
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  margin: 0;
  padding: 0 2px;
  border: 2px solid var(--xv-accent, #217346);
  background: var(--xv-background, #ffffff);
  outline: none;
  resize: none;
  overflow: hidden;
  line-height: normal;
  field-sizing: content;
  user-select: text;
}

.xv__guide,
.xv__size-tip {
  display: none;
  position: absolute;
  z-index: 2;
  pointer-events: none;
}

.xv__guide {
  background: var(--xv-guide, #000000);
}

.xv__size-tip {
  padding: 2px 6px;
  border: 1px solid var(--xv-tip-border, #767676);
  background: var(--xv-tip-background, #ffffff);
  color: var(--xv-text, #000000);
  font-size: 12px;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.xv__dialog {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
}

.xv__dialog--open {
  display: flex;
}

.xv__dialog-box {
  max-width: 420px;
  margin: 16px;
  padding: 16px 20px;
  border: 1px solid var(--xv-head-border, #d4d4d4);
  background: var(--xv-background, #ffffff);
  color: var(--xv-text, #000000);
  font-size: 13px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.xv__dialog-title {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
}

.xv__dialog-link {
  margin-top: 8px;
  color: var(--xv-head-text, #444444);
  word-break: break-all;
}

.xv__dialog-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.xv__dialog-button {
  min-width: 80px;
  padding: 4px 12px;
  border: 1px solid var(--xv-head-border, #d4d4d4);
  background: var(--xv-head-background, #f3f3f3);
  font: inherit;
  cursor: pointer;
}

.xv__dialog-button:focus {
  outline: 2px solid var(--xv-accent, #217346);
  outline-offset: 1px;
}

.xv__tabs {
  flex: 0 0 auto;
  gap: 2px;
  overflow-x: auto;
  padding: 0 4px 4px;
  background: var(--xv-head-background, #f3f3f3);
  border-top: 1px solid var(--xv-head-border, #d4d4d4);
}

.xv__tab {
  padding: 4px 12px;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  font: inherit;
  font-size: 12px;
  white-space: nowrap;
  color: var(--xv-head-text, #444444);
  cursor: pointer;
}

.xv__tab--active {
  background: var(--xv-background, #ffffff);
  font-weight: 600;
  color: var(--xv-accent, #217346);
  border-bottom-color: var(--xv-accent, #217346);
}

.xv-pane__grid,
.xv-pane__eraser,
.xv-pane__fill,
.xv-pane__bar,
.xv-pane__icon,
.xv-pane__text,
.xv-pane__edge,
.xv-pane__diagonal,
.xv-pane__image,
.xv-pane__shade,
.xv-pane__range,
.xv-pane__handle,
.xv-pane__copied {
  position: absolute;
  box-sizing: border-box;
}

.xv-pane__grid {
  background: var(--xv-grid, #e1e1e1);
}

.xv-pane__eraser {
  background: var(--xv-background, #ffffff);
}

.xv-pane__icon {
  display: flex;
  align-items: center;
}

.xv-pane__text {
  overflow: hidden;
  color: #000000;
}

.xv-pane__text--line,
.xv-pane__text--line .xv-pane__content {
  white-space: pre;
}

.xv-pane__text--line .xv-pane__content {
  position: absolute;
}

.xv-pane__text--block {
  display: flex;
  flex-direction: column;
}

.xv-pane__text--block .xv-pane__content {
  overflow-wrap: anywhere;
}

.xv-pane__text--split {
  display: flex;
  white-space: pre;
}

.xv-pane__spacer {
  flex: 1 1 auto;
}

.xv-pane__diagonal {
  overflow: visible;
}

.xv-pane__image,
.xv-pane__shade,
.xv-pane__range,
.xv-pane__handle,
.xv-pane__copied {
  pointer-events: none;
}

.xv-pane__shade {
  fill: var(--xv-selection-shade, rgba(0, 0, 0, 0.12));
}

.xv-pane__range {
  border: 2px solid var(--xv-accent, #217346);
}

.xv-pane__handle {
  width: 7px;
  height: 7px;
  background: var(--xv-accent, #217346);
  border: 1px solid var(--xv-background, #ffffff);
}

.xv-pane__copied {
  border: 2px dashed var(--xv-accent, #217346);
  animation: xv-copied 0.6s linear infinite;
}

@keyframes xv-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes xv-copied {
  50% {
    border-color: var(--xv-background, #ffffff);
  }
}
`;
